export const messages: { [key: string]: ToastrMessage } = {
	www_success: { type: 'success', message: 'Je wachtwoord is gewijzigd.' },
};

export type ToastrMessage = {
	type: 'success' | 'info' | 'error' | 'warning';
	message: string;
};
